module.exports = __webpack_public_path__ + "static/media/bolso.a746da9e.png";